exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1nSQv_69P2ysIfXseg3ZZx{height:100%;width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center}._1nSQv_69P2ysIfXseg3ZZx .xy8M7-WXekKZpajpc8fqF{color:#757575;font-size:15px;line-height:19px;padding-top:15px}._1nSQv_69P2ysIfXseg3ZZx ._2gGkscFfMKsFimxgMExcDV{height:100px;width:100px;display:flex;align-items:center;justify-content:center;border:2px solid #c8e6dc;border-radius:100%}._1nSQv_69P2ysIfXseg3ZZx ._2gGkscFfMKsFimxgMExcDV>span{color:#9e9e9e}\n", ""]);

// Exports
exports.locals = {
	"EmptyPlaceholder": "_1nSQv_69P2ysIfXseg3ZZx",
	"text": "xy8M7-WXekKZpajpc8fqF",
	"border": "_2gGkscFfMKsFimxgMExcDV"
};